import { nativeJSBridge, nativeJSBridgeSync } from './nativeJSBridge'
import { IStorage, IBridgeOptions } from './interface'

/**
 * 读取本地数据
 *
 * @param {IBridgeOptions<IStorage>} {
 *   key,
 *   value,
 *   scope,
 *   domain,
 *   multi_param,
 *   success,
 *   fail,
 *   complete
 * }
 */
function getStorageSync({
  key,
  scope,
  domain,
  multi_param,
  success,
  fail,
  complete
}: IBridgeOptions<IStorage>) {
  const params = {
    key,
    scope,
    domain,
    multi_param
  }
  const opts = {
    method: 'native.readData',
    params,
    success,
    fail,
    complete
  }
  try {
    nativeJSBridgeSync(opts)
  } catch (error) {
    console.log('getStorageSync error: ', error)
  }
}

/**
 * 读取本地数据
 * 一个异步接口，支持 Promise 化使用
 * @param {IBridgeOptions<IStorage>} { key, scope, domain, multi_param }
 * @returns
 */
function getStorage({ key, scope, domain, multi_param }: IBridgeOptions<IStorage>) {
  const params = {
    key,
    scope,
    domain,
    multi_param
  }
  const opts = {
    method: 'native.readData',
    params
  }

  return nativeJSBridge(opts)
}

export { getStorage, getStorageSync }
